import * as Types from '../../api/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type AuthenticateUserMutationVariables = Types.Exact<{
  data: Types.AuthenticatedVisitorInput;
}>;


export type AuthenticateUserMutation = { __typename?: 'Mutation', AuthenticateUser?: { __typename?: 'AuthenticateResult', ok: boolean } | null };


export const AuthenticateUserDocument = gql`
    mutation AuthenticateUser($data: AuthenticatedVisitorInput!) {
  AuthenticateUser(data: $data) {
    ok
  }
}
    `;
export type AuthenticateUserMutationFn = ApolloReactCommon.MutationFunction<AuthenticateUserMutation, AuthenticateUserMutationVariables>;

/**
 * __useAuthenticateUserMutation__
 *
 * To run a mutation, you first call `useAuthenticateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateUserMutation, { data, loading, error }] = useAuthenticateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAuthenticateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticateUserMutation, AuthenticateUserMutationVariables>(AuthenticateUserDocument, options);
      }
export type AuthenticateUserMutationHookResult = ReturnType<typeof useAuthenticateUserMutation>;
export type AuthenticateUserMutationResult = ApolloReactCommon.MutationResult<AuthenticateUserMutation>;
export type AuthenticateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>;